import React, { Component } from 'react';
import EstacionesCocinaAPI from '../../services/EstacionesCocina';
import ClasificacionesAPI from '../../services/Classification';
import PresentationsAPI from '../../services/Presentations';
import FlavorsAPI from '../../services/Flavor';
import MilksAPI from '../../services/Milk';
import GrainsAPI from '../../services/Grain';
import RecipesTypesAPI from '../../services/RecipeType';
import to from '../../util/to';
import { toast } from 'react-toastify';
import Field from '../util/field/Field';
import TableTemplate from '../util/tabletemplate/TableTemplate';
import Dropdown from '../util/dropdown/Dropdown';
import SearchForm from "../util/searchform/SearchForm";
import NoItems from "../util/noitems/NoItems";
import Pagination from '../util/pagination/Pagination';
import Loading from '../util/loading/Loading';
import Select from 'react-select';
import '../cssComponents.css';
import RecipeFilters from '../util/recipeFilters/recipeFilters';
import ErrorMessages from '../../util/validation-error-messages';


class AsignarRecetasEstacion extends Component {
    recetasEstacionesCocina = [];
    recetasEstacionCocinaAux = [];

    // Variables donde se almacenaran los valores seleccionados en el select multi
    tempRecipeTypesList;
    tempPresentationList;
    tempMilkList;
    tempGrainList;
    tempFlavorsList;
    tempClassificationList;

    constructor(props) {
        super(props);
        this.state = {
            filters: {
                idClasificacion: 0,
                idPresentacion: 0,
                idTipoSabor: 0,
                idTipoReceta: 0,
                idTipoLeche: 0,
                idTipoGrano: 0
            },
            recetasEstacionCocinaAux: [],
            pageEstacionReceta: [],
            filterText: "",
            classifications: [],
            presentations: [],
            flavors: [],
            recipeTypes: [],
            milks: [],
            grains: [],
            isLoading: false,
            dataLoaded: false,
            checkAll: false,//para seleccionar todos los de una pagina (1er checkBox)
            activateMasive: false,//Activar o desactivar masivo (Apartado que se muestra o no dependiendo del estado)
            switchAll: false,//switch para activar o desactivar
            seeSwitch: false,//variable par mostrar switch
            buttonMesagge: false,//nos ayuda a mostrar un texto personalizado en el boton Seleccionar todo
            // Variables sonde se almacenaran los criterios de busqueda definitivos
            recipeTypeList: [],
            selectedRecipeTypesList: [],
            presentationsList: [],
            selectedPresentationsList: [],
            milksList: [],
            selectedMilksList: [],
            grainsList: [],
            selectedGrainsList: [],
            flavorsList: [],
            selectedFlavorsList: [],
            classificationList: [],            
            selectedClassificationList: [],            
            selectedSegmentationList: [],
            selectedEstacionReceta: [],
            estacionCocinaList: [],
            estacionCocinaSeleccionada: null,
        };
    }

    componentWillMount() {
        this.setState({ isLoading: true });

        EstacionesCocinaAPI.getByRecetasByEstacion(this.props.match.params.id).then(response => {
            if(response.data.length === 0){
                toast.error("No hay recetas asignadas a esta estación de cocina");
                this.setState({ recetasEstacionCocinaAux: [], isLoading: false });
            }else{
                this.recetasEstacionesCocina = response.data;
                var info = response.data.map((item, index) => {
                    return {
                        IdRelRecetasEstacion: index,
                        IdEstacion: item.IdEstacion,
                        idReceta: item.idReceta,
                        Activo: item.Activo,
                        idClasificacion: item.idClasificacion,
                        idPresentacion: item.idPresentacion,
                        idTipoSabor: item.idTipoSabor,
                        idTipoReceta: item.idTipoReceta,
                        idTipoLeche: item.idTipoLeche,
                        idTipoGrano: item.idTipoGrano,
                        Descripcion: item.Descripcion,
                        idSegmento: item.idSegmento,
                        statusCheck: false//agregamos un estado para cada fila de si ha sido seleccionado no
                    };
                });

                this.recetasEstacionCocinaAux = info;
                
                this.setState({ recetasEstacionCocinaAux: info }, () => this.getData());
            }
        }).catch(err => {
            if(err.response)
                    toast.error(err.response.data);
                else
                    toast.error(ErrorMessages.SinConexion);
            this.setState({ recetasEstacionCocinaAux: [], isLoading: false });
        })
    }


    getData = async () => {
        let err, classifications, presentations, flavors, milks, grains, recipeTypes, estacionCocina;
        [err, classifications] = await to(ClasificacionesAPI.getAll());
        [err, presentations] = await to(PresentationsAPI.getAll());
        [err, flavors] = await to(FlavorsAPI.getAll());
        [err, milks] = await to(MilksAPI.getAll());
        [err, grains] = await to(GrainsAPI.getAll());
        [err, recipeTypes] = await to(RecipesTypesAPI.getAll());
        [err, estacionCocina] = await to(EstacionesCocinaAPI.getAll());

        let tempClassificationList = [];
        classifications.map(obj => {
            tempClassificationList.push({ value: obj.idClasificacion, label: obj.ShortName })
        })
        tempClassificationList.sort(this.compare); // Ordenar los labels

        let temp = [];
        recipeTypes.map(obj => {
            if (obj.RecipeName) {
                temp.push({ value: obj.idTipoReceta, label: obj.RecipeName })
            } else {
                temp.push({ value: obj.idTipoReceta, label: obj.Description })
            }
        })
        temp.sort(this.compare); // Ordenar los labesl para elegir

        let tempFlavorsList = [];
        flavors.map(obj => {
            tempFlavorsList.push({ value: obj.idTipoSabor, label: obj.Name })
        })
        tempFlavorsList.sort(this.compare); // Ordenar los labels     

        let tempGrainList = [];
        grains.map(obj => {
            tempGrainList.push({ value: obj.idTipoGrano, label: obj.Description })
        })
        tempGrainList.sort(this.compare); // Ordenar los labels

        let tempMilkList = [];
        milks.map(obj => {
            tempMilkList.push({ value: obj.idTipoLeche, label: obj.Description })
        })
        tempMilkList.sort(this.compare); // Ordenar los labels

        let tempPresentationList = [];
        presentations.map(obj => {
            tempPresentationList.push({ value: obj.idPresentacion, label: obj.Name })
        })
        tempPresentationList.sort(this.compare); // Ordenar los labels


        let tempEstacionCocinaList = [];
        estacionCocina.map(obj => {
            tempEstacionCocinaList.push({ value: obj.IdEstacion, label: obj.Descripcion })
        })
        tempEstacionCocinaList.sort(this.compare); // Ordenar los labels

        this.setState({
            classificationList: tempClassificationList,
            recipeTypeList: temp,
            flavorsList: tempFlavorsList,
            grainsList: tempGrainList,
            milksList: tempMilkList,
            presentationsList: tempPresentationList,
            estacionCocinaList: tempEstacionCocinaList,
            dataLoaded: true,
            isLoading: false
        })
    }

    handleDropdownChange = (index, itemName, propName) => {
        if (index != 0) {
            let item = this.state[itemName][index - 1];
            let state = { ...this.state };
            state.filters[propName] = item[propName];
            this.setState(state, () => this.filterDataOnPages());
        } else {
            let state = { ...this.state };
            state.filters[propName] = 0;
            this.setState(state, () => this.filterDataOnPages());
        }
    }


    filterDataOnPages = () => {

        let details = this.recetasEstacionCocinaAux;

        if (this.state.filters.idClasificacion) {
            details = details.filter(d => d.idClasificacion == this.state.filters.idClasificacion);
        }

        if (this.state.filters.idPresentacion) {
            details = details.filter(d => d.idPresentacion == this.state.filters.idPresentacion);
        }

        if (this.state.filters.idTipoSabor) {
            details = details.filter(d => d.idTipoSabor == this.state.filters.idTipoSabor);
        }

        if (this.state.filters.idTipoReceta) {
            details = details.filter(d => d.idTipoReceta == this.state.filters.idTipoReceta);
        }

        if (this.state.filters.idTipoLeche) {
            details = details.filter(d => d.idTipoLeche == this.state.filters.idTipoLeche);
        }

        if (this.state.filters.idTipoGrano) {
            details = details.filter(d => d.idTipoGrano == this.state.filters.idTipoGrano);
        }

        if (this.state.filterText) {
            details = details.filter(d => d.Description.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(this.state.filterText.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")));
        }

        this.setState({ recetasEstacionCocinaAux: details });
    }

    // Método encargado de recibir el texto en el input de búsqueda y filtrar los elementos en
    // la tabla 
    handleSearchInput = (text) => {
        //let menus = this.menus.filter(menu => menu.Description.toLowerCase().includes(text.toLowerCase()));
        //state.menus = menus;

        let state = this.state;
        state.filterText = text;
        this.setState(state);
        this.handleSearchMultipleFieldInput();
        // this.filterDataOnPages();
    }

    //Funcion para marcar todos los checkbox que hay en la pagina actual
    selectAllCheck = () => {
        let _selectedEstacionReceta = [...this.state.selectedEstacionReceta];
        let _estacionReceta = this.state.pageEstacionReceta
        let _checkAll = !this.state.checkAll

        _estacionReceta.forEach(estacionReceta => {
            let indexEstacionReceta = _selectedEstacionReceta.findIndex(item => item.idReceta === estacionReceta.idReceta)
            estacionReceta.statusCheck = _checkAll
            if(_checkAll){
                if(indexEstacionReceta === -1) _selectedEstacionReceta.push({
                    IdEstacion: estacionReceta.IdEstacion,
                    idReceta: estacionReceta.idReceta,
                    IdRelRecetasEstacion: estacionReceta.IdRelRecetasEstacion
                })
            }else{
                if(indexEstacionReceta !== -1) _selectedEstacionReceta.splice(indexEstacionReceta, 1)
            }
        })

        this.setState({
            selectedEstacionReceta: _selectedEstacionReceta, 
            checkAll: _checkAll,
            buttonSelectAll: _selectedEstacionReceta.length === this.state.recetasEstacionCocinaAux.length,
            activateMasive: _selectedEstacionReceta.length > 0
        })
    }

    //Funcion que selecciona o des selecciona todos los checkbox de todas las paginas
    selectAllCheckBox = () => {
        let _selectedEstacionReceta = [...this.state.selectedEstacionReceta]
        let _estacionReceta = this.state.recetasEstacionCocinaAux;
        let _buttonSelectAll = !this.state.buttonSelectAll;

        _estacionReceta.forEach(estacionReceta => {
            // Ver si el elemento ya esta en la lista de seleccioandos
            let indexEstacionReceta = _selectedEstacionReceta.findIndex(item => item.idReceta === estacionReceta.idReceta)

            // Meter el elemento a la lista si no estaba previamente
            if (_buttonSelectAll && indexEstacionReceta === -1) {
                _selectedEstacionReceta.push({
                    IdEstacion: estacionReceta.IdEstacion,
                    idReceta: estacionReceta.idReceta,
                    IdRelRecetasEstacion: estacionReceta.IdRelRecetasEstacion
                })
            // Sacar al elemento de la lista si ya estaba
            } else if (!_buttonSelectAll && indexEstacionReceta !== -1) {
                _selectedEstacionReceta.splice(indexEstacionReceta, 1)
            }
            estacionReceta.statusCheck = _buttonSelectAll;
        })

        let _checkAll = _buttonSelectAll;

        this.setState({
            selectedEstacionReceta: _selectedEstacionReceta, 
            checkAll: _checkAll,
            buttonSelectAll: _buttonSelectAll,
            activateMasive: _selectedEstacionReceta.length > 0
        })
    }

    //Funcion que sirve cuando damos clic a un check de una columna 
    //para que nos muestre la opcion de aplicar cambios global
    showView = (index) => {
        let _selectedEstacionReceta = [...this.state.selectedEstacionReceta];
        let indexEstacionReceta = this.state.selectedEstacionReceta.findIndex(id => id.idReceta === this.state.pageEstacionReceta[index].idReceta)
        if (indexEstacionReceta === -1) {
            // Meter todo el objeto al arreglo de seleccionados
            _selectedEstacionReceta.push({
                IdEstacion: this.state.pageEstacionReceta[index].IdEstacion,
                idReceta: this.state.pageEstacionReceta[index].idReceta,
                IdRelRecetasEstacion: this.state.pageEstacionReceta[index].IdRelRecetasEstacion
            })
        } else {
            _selectedEstacionReceta.splice(indexEstacionReceta, 1)
        }

        let counter = 0; // variable para comparar los elementos seleccionados en la pagina con la cantidad de elementos por pagina
        this.state.pageEstacionReceta.map(obj => {
            if (obj.statusCheck) counter++
        })

        this.setState({
            selectedEstacionReceta: _selectedEstacionReceta, 
            buttonSelectAll: _selectedEstacionReceta.length === this.state.recetasEstacionCocinaAux.length,
            checkAll: counter === this.state.pageEstacionReceta.length,
            activateMasive: _selectedEstacionReceta.length > 0
        })
    }

    //Funcion para guardar masivamente los cambios hechos
    applySwitchAll = () => {
        // Ponemos icono de cargando
        this.setState({ isLoading: true });

        this.state.selectedEstacionReceta.map(obj => {
            obj.IdEstacion = this.state.estacionCocinaSeleccionada.value
        })

        EstacionesCocinaAPI.agregarRecetasEstacion(this.state.selectedEstacionReceta).then(response => {
            if (response.data) {
                // Ids de las recetas que se acaban de asignar
                let idsAsignados = this.state.selectedEstacionReceta.map(item => item.idReceta);

                // Actualizamos la fuente de verdad (propiedad de instancia) usada por filterDataOnPages
                this.recetasEstacionCocinaAux = this.recetasEstacionCocinaAux.filter(
                    item => !idsAsignados.includes(item.idReceta)
                );

                // Quitamos esas recetas también del state para que la tabla se refresque
                let nuevoRecetasEstacionCocinaAux = this.state.recetasEstacionCocinaAux.filter(
                    item => !idsAsignados.includes(item.idReceta)
                );
                let nuevaPageEstacionReceta = this.state.pageEstacionReceta.filter(
                    item => !idsAsignados.includes(item.idReceta)
                );

                this.setState({
                    recetasEstacionCocinaAux: nuevoRecetasEstacionCocinaAux,
                    pageEstacionReceta: nuevaPageEstacionReceta,
                    selectedEstacionReceta: [],
                    estacionCocinaSeleccionada: null,
                    checkAll: false,
                    buttonSelectAll: false,
                    activateMasive: false,
                    isLoading: false
                }, () => {
                    toast.success("Recetas asignadas correctamente");
                });
            } else {
                this.setState({ isLoading: false });
                toast.error("Ocurrió un error al asignar las recetas");
            }
        }).catch(err => {
            let state = { ...this.state };
            state.showModal = false;
            state.isLoading = false;
            this.setState(state);

            toast.error("Ocurrió un error al actualizar la Receta");
        });
    }

    applySwitchAllEliminar = () => {
        // Ponemos icono de cargando
        this.setState({ isLoading: true });

        EstacionesCocinaAPI.eliminarRecetasEstacion(this.state.selectedEstacionReceta).then(response => {
            if (response.data) {
                // Ids de las recetas que se acaban de asignar
                let idsAsignados = this.state.selectedEstacionReceta.map(item => item.idReceta);

                // Actualizamos la fuente de verdad (propiedad de instancia) usada por filterDataOnPages
                this.recetasEstacionCocinaAux = this.recetasEstacionCocinaAux.filter(
                    item => !idsAsignados.includes(item.idReceta)
                );

                // Quitamos esas recetas también del state para que la tabla se refresque
                let nuevoRecetasEstacionCocinaAux = this.state.recetasEstacionCocinaAux.filter(
                    item => !idsAsignados.includes(item.idReceta)
                );
                let nuevaPageEstacionReceta = this.state.pageEstacionReceta.filter(
                    item => !idsAsignados.includes(item.idReceta)
                );

                this.setState({
                    recetasEstacionCocinaAux: nuevoRecetasEstacionCocinaAux,
                    pageEstacionReceta: nuevaPageEstacionReceta,
                    selectedEstacionReceta: [],
                    estacionCocinaSeleccionada: null,
                    checkAll: false,
                    buttonSelectAll: false,
                    activateMasive: false,
                    isLoading: false
                }, () => {
                    toast.success("Recetas eliminadas correctamente");
                });
            } else {
                this.setState({ isLoading: false });
                toast.error("Ocurrió un error al eliminar las recetas");
            }
        }).catch(err => {
            let state = { ...this.state };
            state.showModal = false;
            state.isLoading = false;
            this.setState(state);

            toast.error("Ocurrió un error al actualizar la Receta");
        });
    }

    changeStatusDetail = (detail) => {

        this.setState({ isLoading: true });
        let infoService = [
            {
                IdEstacion: detail.IdEstacion,
                idReceta: detail.idReceta,
                Activo: !detail.Activo
            }
        ];

        EstacionesCocinaAPI.postDetailUpdate(infoService).then(response => {
            let state = { ...this.state };

            detail.Activo = !detail.Activo;
            state.recetasEstacionCocinaAux[state.recetasEstacionCocinaAux.findIndex(md => md.IdRelRecetasEstacion === detail.IdRelRecetasEstacion)] = detail;
            state.pageEstacionReceta[state.pageEstacionReceta.findIndex(md => md.IdRelRecetasEstacion === detail.IdRelRecetasEstacion)] = detail;

            state.showModal = false;
            state.isLoading = false;
            this.setState(state, () => {
                toast.success("Datos actualizados");
            });
        }).catch(err => {
            let state = { ...this.state };
            state.showModal = false;
            state.isLoading = false;
            this.setState(state);

            toast.error("Ocurrió un error al actualizar la Receta.");
        });
    }

    /**
     * Funcion para ordenar lexicograficamente
     * @param objA. primer operando
     * @param objB. segundo operando
     */
    compare = (objA, objB) => {
        // Use toUpperCase() to ignore character casing
        const labelA = objA.label.toUpperCase();
        const labelB = objB.label.toUpperCase();

        let comparison = 0;
        if (labelA > labelB) {
            comparison = 1;
        } else if (labelA < labelB) {
            comparison = -1;
        }
        return comparison;
    }

    /**
     *Realizar el filtrado sobre las recetas para desplegar solo los elementos
     *que cumplen con las caracteristicas que el usuario ingreso.
     * 
     *@param: nada
     *@return: nada
     */
    handleSearchMultipleFieldInput = () => {

        let state = this.state;

        let recetasEstacionCocinaAux = this.recetasEstacionCocinaAux;

        if (this.state.selectedRecipeTypesList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedRecipeTypesList.includes(d.idTipoReceta))
        }

        if (this.state.selectedFlavorsList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedFlavorsList.includes(d.idTipoSabor))
        }

        if (this.state.selectedPresentationsList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedPresentationsList.includes(d.idPresentacion))
        }

        if (this.state.selectedMilksList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedMilksList.includes(d.idTipoLeche));
        }

        if (this.state.selectedGrainsList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedGrainsList.includes(d.idTipoGrano))
        }

        if (this.state.selectedClassificationList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedClassificationList.includes(d.idClasificacion));
        }

        if (this.state.selectedSegmentationList.length > 0) {
            recetasEstacionCocinaAux = recetasEstacionCocinaAux.filter(d => this.state.selectedSegmentationList.includes(d.idSegmento));
        }
        

        recetasEstacionCocinaAux.map(item=>{
            if(item.statusCheck){
                item.statusCheck = false;
            } 
        });

        state.recetasEstacionCocinaAux = recetasEstacionCocinaAux;
        state.activateMasive = false;
        state.buttonSelectAll = false;
        state.selectedEstacionReceta = []

        this.setState(state);
    }

    /**
     *Modificar la lista de IDs con los que el usuario ha seleccionado. Aplica sobre las clasificaciones.
     * 
     *@param: arr: arreglo de valores que crea el select multi de react
     *@return: nada
     */
    handleClassificationChange = (arr) => {
        let state = { ...this.state }
        let tempClassificationList = [];
        arr.map(obj => {
            tempClassificationList.push(obj.value);
        })

        state.selectedClassificationList = tempClassificationList;
        state.selectedRecipes = [];

        this.setState(state, () => {
            this.handleSearchMultipleFieldInput();
        });
    }

    /**
     *Modificar la lista de IDs con los que el usuario ha seleccionado. Aplica sobre los tipos de receta
     * 
     *@param: arr: arreglo de valores que crea el select multi de react
     *@return: nada
     */
    handleRecipeTypeChange = (arr) => {
        let state = { ...this.state }
        let tempSelectedRecipeTypesList = [];
        arr.map(obj => {
            tempSelectedRecipeTypesList.push(obj.value);
        })

        state.selectedRecipeTypesList = tempSelectedRecipeTypesList;
        state.selectedRecipes = [];

        this.setState(state, () => {
            this.handleSearchMultipleFieldInput();
        });
    }

    /**
     *Modificar la lista de IDs con los que el usuario ha seleccionado. Aplica sobre los tipos de sabores
     * 
     *@param: arr: arreglo de valores que crea el select multi de react
     *@return: nada
     */
    handleFlavorChange = (arr) => {
        let state = { ...this.state }
        let tempSelectedFlavorList = [];
        arr.map(obj => {
            tempSelectedFlavorList.push(obj.value);
        })

        state.selectedFlavorsList = tempSelectedFlavorList;
        state.selectedRecipes = [];

        this.setState(state, () => {
            this.handleSearchMultipleFieldInput();
        });
    }

    /**
     *Modificar la lista de IDs con los que el usuario ha seleccionado. Aplica sobre los tipos de granos.
     * 
     *@param: arr: arreglo de valores que crea el select multi de react
     *@return: nada
     */
    handleGrainChange = (arr) => {
        let state = { ...this.state }
        let tempGrainList = [];
        arr.map(obj => {
            tempGrainList.push(obj.value);
        })

        state.selectedGrainsList = tempGrainList;
        state.selectedRecipes = [];

        this.setState(state, () => {
            this.handleSearchMultipleFieldInput();
        });
    }

    /**
     *Modificar la lista de IDs con los que el usuario ha seleccionado. Aplica sobre los tipos de leche
     * 
     *@param: arr: arreglo de valores que crea el select multi de react
     *@return: nada
     */
    handleMilkChange = (arr) => {
        let state = { ...this.state }
        let tempMilksList = [];
        arr.map(obj => {
            tempMilksList.push(obj.value);
        })

        state.selectedMilksList = tempMilksList;
        state.selectedRecipes = [];

        this.setState(state, () => {
            this.handleSearchMultipleFieldInput();
        });
    }

    /**
     *Modificar la lista de IDs con los que el usuario ha seleccionado. Aplica sobre las presentaciones
     * 
     *@param: arr: arreglo de valores que crea el select multi de react
     *@return: nada
     */
    handlePresentationChange = (arr) => {
        let state = { ...this.state }
        let tempPresentationList = [];
        arr.map(obj => {
            tempPresentationList.push(obj.value);
        })

        state.selectedPresentationsList = tempPresentationList;
        state.selectedRecipes = [];

        this.setState(state, () => {
            this.handleSearchMultipleFieldInput();
        });
    }

    /**
     * Función para manejar el onChange del componente de RecipeFilters
     */
    handleSelectChange = (objFilters) => {
        this.setState(objFilters, () => {this.handleSearchMultipleFieldInput();})
    }

    /**
     * Función para manejar los radiobuttons para el filtro de estatus
     */
    handleFiltroEstatus= (evento) => {
        if(this.state.selectedEstatus !== Number(evento.currentTarget.value)){
            this.setState({selectedEstatus: Number(evento.currentTarget.value)}, this.handleSearchMultipleFieldInput)
        }
    }

    render() {
        return (
            <div>
                <div className="card">
                    <div className="card-header">
                        <div className="card-header-title is-size-4 center-text">
                            <span style={{position:"absolute", left: 25}} className="is-primary tooltip" data-tooltip="Ir Atrás">
                                <i className="fa-5x" style={{cursor: "pointer", color: "#91BA43" }} onClick={() => {this.props.history.goBack()}} className="fa fa-arrow-left"></i>
                            </span>
                            {this.props.location.state.name}
                        </div>
                    </div>
                    <div className="card-content">

                        {/* Filtrado de todo */}
                        <div className="columns is-multiline">
                            <RecipeFilters 
                                onChange={(objFilters) => {
                                    this.handleSelectChange(objFilters)
                                }}
                            />                            
                        </div>

                    </div>
                </div>
                <br />
                {/*Mostramos cuando a seleccionado un checkbox*/}
                {
                    this.state.activateMasive && this.props.match.params.id == 0 &&
                    <div className="card">
                        <div className="card-content">
                            <div className="columns">
                                <div className="column is-4">
                                    <label className="label">Asignar Estación de Cocina</label>
                                </div>
                                <div className="column is-6">
                                    <Select
                                        id={"ddlEstacionCocina"}
                                        placeholder={"Seleccionar Estación..."}
                                        name={"bus_1"}
                                        value={this.state.estacionCocinaSeleccionada}
                                        onChange={(selectedOption) => {
                                            this.setState({ estacionCocinaSeleccionada: selectedOption });
                                        }}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={this.state.estacionCocinaList}
                                    />
                                </div>
                                <div className="column is-2">
                                    <div className="has-text-right buttons-modal">
                                        <button
                                            className="button is-success"
                                            disabled={!this.state.estacionCocinaSeleccionada}
                                            onClick={() => this.applySwitchAll()}>
                                            Aplicar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {
                    this.state.activateMasive && this.props.match.params.id != 0 &&
                    <div className="card">
                        <div className="card-content">
                            <div className="columns">
                                <div className="column is-4">
                                    <label className="label">Quitar Estación de Cocina</label>
                                </div>
                                <div className="column is-2">
                                    <div className="has-text-right buttons-modal">
                                        <button
                                            className="button is-success"
                                            onClick={() => this.applySwitchAllEliminar()}>
                                            Aplicar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <br />

                <div className="card">
                    <div className="card-content">
                        <div className="columns">
                            <div className="column is-3">
                                <div className="has-text-center">
                                    <a className="button is-link" onClick={() => this.selectAllCheckBox()}>
                                        <span className="icon is-small">
                                            <i className={!this.state.buttonSelectAll ? "fa fa-check-square" : "fa fa-square"}></i>
                                        </span>
                                        <span>{!this.state.buttonSelectAll ? "Seleccionar todos los resultados" : "Deseleccionar todos los resultados"}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-content">
                        {this.state.recetasEstacionCocinaAux.length != 0
                            ? <TableTemplate
                                columns={["idReceta", "Descripcion"]}
                                columnsNames={["ID", "Receta"]}
                                disableCheck={false}
                                data={this.state.pageEstacionReceta}
                                noActions={true}
                                checkbox={true}
                                checkAll={this.state.checkAll}
                                showView={this.showView}
                                selectAllCheck={this.selectAllCheck}
                                changeStatus={this.changeStatusDetail}
                            />
                            : <NoItems itemName="recetas asignadas a la estación de cocina" />}

                        <Pagination 
                            items={this.state.recetasEstacionCocinaAux} 
                            onChangePage={
                                (recetasEstacionCocinaAux) => {
                                    let checkAllTemp = true;
                                    let cheked = false;

                                    recetasEstacionCocinaAux.map(item => {
                                        if(item.statusCheck){
                                            cheked = true;
                                        } else {
                                            checkAllTemp = false;
                                        }
                                    })
                                    this.setState({ pageEstacionReceta: recetasEstacionCocinaAux, checkAll: checkAllTemp, seeSwitch: this.state.selectedClassificationList.length > 0 })
                                }
                            } 
                        />


                    </div>
                </div>
                <Loading isFullscreen={true} isLoading={this.state.isLoading} width='100px' height='100px' />
            </div>
        );
    }

}

export default AsignarRecetasEstacion;